import { getSlotLabel } from 'Components/widgets/reservation-block/PopInReservationBlockMorningAfternoonExclusive';
import { capitalize } from 'lodash';
import moment from 'moment';
import { t } from 'Src/i18n';
import { formatApiTime } from 'Utils/date/apiDate';

export const getSpecificChildcareLabel = (currentChildInfo) => {
  const hasManySchedules = currentChildInfo?.schedules.length > 1;

  const rentedSchedules = currentChildInfo?.schedules.filter(
    ({ isPartiallyRented }) => isPartiallyRented,
  );

  const rentedSchedulesNumber = rentedSchedules?.length;

  const scheduleHasDifferentStartEndDates =
    rentedSchedules[0]?.startDate !== rentedSchedules[0]?.endDate;

  const hasRentedFullStaySchedule =
    rentedSchedulesNumber === 1 && scheduleHasDifferentStartEndDates;

  const hasRentedAtLeastOneSingleDaySchedule =
    rentedSchedules.length > 1 ||
    (rentedSchedulesNumber === 1 && rentedSchedules[0].startDate === rentedSchedules[0].endDate);

  if (hasManySchedules && hasRentedAtLeastOneSingleDaySchedule) {
    // here is the case of one or many days from the stay
    // we display { n } days
    return t('common.dateTime.day', { count: rentedSchedulesNumber });
  }
  if (hasRentedFullStaySchedule) {
    // here is the case of renting the full stay slot but in the case of childcare by day
    // or the case of renting the full stay slot but in the case of the simple childcare
    // here is the case of slots
    const selectedSlots = rentedSchedules?.[0]?.timeSlots?.filter(({ isRented }) => isRented);
    // for now we only select one slot for the exclusivity of morning or afternoon or all day
    const slotName = selectedSlots?.[0].slotName;
    return hasManySchedules ? t('booking.activities.childcare.allStay') : getSlotLabel(slotName);
  }

  return '';
};

export const mapOpeningHours = ({ start, end }) => {
  const formattedStart = formatApiTime(start, 'LT').toLowerCase();
  const formattedEnd = formatApiTime(end, 'LT').toLowerCase();

  return t('booking.services.childcare.openingHours', {
    ' opening_hours - start ': formattedStart,
    ' opening_hours - end ': formattedEnd,
  });
};
export const dayIds = {
  SU: 0,
  MO: 1,
  TU: 2,
  WE: 3,
  TH: 4,
  FR: 5,
  SA: 6,
};

export const mapClosingDays = (closingAbbr) => {
  const index = dayIds[closingAbbr.toUpperCase()];
  if (index === undefined) {
    return '';
  }
  const dayName = moment().day(index).format('dddd');
  return capitalize(dayName);
};

export const getClosingDays = (closingWeekdays) => {
  if (!closingWeekdays?.length) {
    return '';
  }

  return t('booking.services.childcare.closingDays', {
    closing_weekdays: closingWeekdays.map(mapClosingDays).join(', '),
  });
};

export const rentedTotalPriceByChild = (childcare, currentChildRentedAmout) => {
  // May be confusing to have startingPricePerAdult for a child but the property is shared between all upsells
  // and now the childcare behaves in a classic upsell way
  const childcareStartingPrice = childcare.pricingInfo.startingPricePerAdult.value;

  const isChildcareUpsell = childcareStartingPrice > 0;
  if (isChildcareUpsell) {
    const hasRentedFromThisChildcare =
      childcare.pricingInfo.attendees?.find(({ id }) => id === childcare.pricingInfo.childId)
        ?.rentedAmount.value > 0;

    if (hasRentedFromThisChildcare) {
      const rentedPrice = `${currentChildRentedAmout.formattedValue}`;

      return rentedPrice;
    }
    return childcare.pricingInfo.startingPricePerAdult.fornattedValue;
  }
  // included
  return t('booking.common.included');
};
